import { render, staticRenderFns } from "./StockConsolidationPage.vue?vue&type=template&id=8347739c&"
import script from "./StockConsolidationPage.vue?vue&type=script&lang=js&"
export * from "./StockConsolidationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports